module.exports = __webpack_public_path__ + "static/media/Sardinia yacht.9394ae08.jpg";